<app-filter-button
  [filterWide]="true"
  (requestReset)="handleReset()"
  [(resetConfirmed)]="resetHandled"
  [filterGroups]="filterGroup"
  [isDepositView]="isDepositView()"
  [hasOtherActiveFilters]="hasDateFilters() || hasCategoryFilters() || hasEmployeeFilters() || hasContactFilter()"
  (applyFilter)="onFilter($event)">
  <div class="mb-3">
    <div class="filter-label">Dates</div>
    <app-date-range-picker
      setMinMaxDateFor="exportTransactions"
      [fromDate]="dateFrom()"
      [toDate]="dateTo()"
      (toDateChange)="setToDate($event)"
      (fromDateChange)="setFromDate($event)">
    </app-date-range-picker>
  </div>

  @if (hasAccounting()) {
    <div class="mb-3">
      <app-contacts-select
        [filterLabel]="true"
        [selectedContact]="selectedContact()"
        (selectionChanged)="updateContact($event)"></app-contacts-select>
    </div>
  }

  @if (!isDepositView()) {
    <div class="mb-3">
      <app-category-select-multi
        [filterLabel]="true"
        [selectedCategories]="selectedCategories()"
        (selectionChanged)="updateCategories($event)">
      </app-category-select-multi>
    </div>

    <div class="mb-3">
      <app-employees-select-multi
        [filterLabel]="true"
        [selectedEmployees]="selectedEmployees()"
        (selectionChanged)="updateEmployees($event)">
      </app-employees-select-multi>
    </div>
  }
</app-filter-button>
